"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var bank = exports.bank = { "viewBox": "0 0 2048 1792", "children": [{ "name": "path", "attribs": { "d": "M960 0l960 384v128h-128q0 26-20.5 45t-48.5 19h-1526q-28 0-48.5-19t-20.5-45h-128v-128zM256 640h256v768h128v-768h256v768h128v-768h256v768h128v-768h256v768h59q28 0 48.5 19t20.5 45v64h-1664v-64q0-26 20.5-45t48.5-19h59v-768zM1851 1600q28 0 48.5 19t20.5 45v128h-1920v-128q0-26 20.5-45t48.5-19h1782z" } }] };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/fa/bank.js
// module id = 767
// module chunks = 1